<template>
  <div class="orders">
    <div v-if="!show">
      <div class="watting-dot"></div>
    </div>
    <div v-else>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-if="!store.state.isMobile"
      >
        <el-table-column
          prop="no"
          :label="$t('orders.order_number')"
          width="200px"
        />
        <el-table-column
          prop="time_limit"
          :label="$t('orders.cycle')"
          align="center"
          width="180px"
        >
          <template #default="scope">
            <div>
              {{ scope.row.pkgType }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orders.order_amount')"
          align="center"
          width="130px"
        >
          <template #default="scope">
            <span v-if="scope.row.currency === 'USD'">$</span>
            <span v-if="scope.row.currency === 'BRL'">R$</span>
            {{ scope.row.totalPrice }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('orders.order_status')"
          width="330px"
        >
          <template #default="scope">
            <div class="flex" v-if="scope.row.status === 'waiting'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/err-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.to_be_paid") }}</div>
            </div>
            <div class="flex" v-if="scope.row.status === 'paying'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/err-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("prompt.paying") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'close'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.cancelled") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'cancel'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.cancel_payment") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'timeout'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.timeOut") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'failed'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.fail") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'success'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/success-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.completed") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'unused'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.unknown") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'rejected'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.chargeback") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'doing'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.processing") }}</div>
            </div>
            <div class="flex" v-else-if="scope.row.status === 'refunded'">
              <div class="m-r-5 flex">
                <img
                  style="width: 18px"
                  src="../../assets/img/cancel-dot.png"
                  alt=""
                />
              </div>
              <div>{{ $t("orders.refunded") }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('orders.creation_time')" width="180px">
          <template #default="scope">
            {{ changeTime(scope.row.createAt) }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('orders.operate')"
          fixed="right"
          width="230px"
          align="center"
        >
          <template #default="scope">
            <el-button
              :type="
                scope.row.status === 'success' ||
                scope.row.status === 'waiting' ||
                scope.row.status === 'paying'
                  ? 'primary'
                  : 'info'
              "
              text
              class="title4"
              :disabled="
                scope.row.status === 'success' ||
                scope.row.status === 'waiting' ||
                scope.row.status === 'paying'
                  ? false
                  : true
              "
              @click="details(scope.row)"
            >
              {{ $t("orders.check_the_details") }}
            </el-button>
            <el-button
              :type="scope.row.status === 'waiting' ? 'primary' : 'info'"
              text
              class="title4"
              :disabled="scope.row.status === 'waiting' ? false : true"
              @click="cancel(scope.row.no)"
            >
              {{ $t("orders.cancel") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="order-item f-FAFAFA border-radius shadow" v-else>
        <!-- change table -->
        <div
          v-for="data in tableData"
          :key="data.no"
          class="c-p"
          @click="details(data)"
        >
          <div class="flex-between">
            <!-- name and status -->
            <div>
              <!-- name -->
              <div class="title2">
                <span>{{ data.pdName }}</span>
              </div>
              <!-- status -->
              <div>
                <div v-if="data.status === 'waiting'">
                  {{ $t("orders.to_be_paid") }}
                </div>
                <div v-else-if="data.status === 'paying'">
                  {{ $t("prompt.paying") }}
                </div>
                <div v-else-if="data.status === 'close'">
                  {{ $t("orders.cancelled") }}
                </div>
                <div v-else-if="data.status === 'cancel'">
                  {{ $t("orders.cancel_payment") }}
                </div>
                <div v-else-if="data.status === 'timeout'">
                  {{ $t("orders.timeOut") }}
                </div>
                <div v-else-if="data.status === 'failed'">
                  {{ $t("orders.fail") }}
                </div>
                <div v-else-if="data.status === 'success'">
                  {{ $t("orders.completed") }}
                </div>
                <div v-else-if="data.status === 'unused'">
                  {{ $t("orders.unknown") }}
                </div>
                <div v-else-if="data.status === 'rejected'">
                  {{ $t("orders.chargeback") }}
                </div>
                <div v-else-if="data.status === 'doing'">
                  {{ $t("orders.processing") }}
                </div>
                <div v-else-if="data.status === 'refunded'">
                  {{ $t("orders.refunded") }}
                </div>
              </div>
            </div>
            <!-- price and icon -->
            <div class="flex-end">
              <div class="m-b-5 m-r-5 f-w-600">
                <span v-if="data.currency === 'USD'">$</span>
                <span v-if="data.currency === 'BRL'">R$</span>
                {{ data.totalPrice }}
              </div>
              <div>
                <el-icon><ArrowRightBold /></el-icon>
              </div>
            </div>
          </div>
          <!-- divider -->
          <el-divider />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ordersApi, cancelOrder } from "@/utils/api";
import { ElNotification, ElMessageBox } from "element-plus";
import { ArrowRightBold } from "@element-plus/icons-vue";
import { useI18n } from "vue-i18n";
import { timeFilter } from "@/utils/tool";
import { useStore } from "vuex";
import { receive_app } from "../../utils/lang_change";
export default {
  setup() {
    const { t, locale } = useI18n();
    const store = useStore();
    let changelanguage = (lang) => {
      locale.value = receive_app(lang);
      sessionStorage.setItem("lang", receive_app(lang));
    };
    return { t, store, changelanguage };
  },
  components: { ArrowRightBold },
  data() {
    return {
      tableData: [],
      total: 100,
      show: false,
    };
  },
  methods: {
    getOrders() {
      this.show = false;
      ordersApi().then((res) => {
        if (res !== undefined) {
          if (res.data.code === 0) {
            this.tableData = res.data.data;
            this.show = true;
          } else {
            return ElNotification({
              title: "error",
              message: res.data.msg,
              type: "error",
            });
          }
        } else {
          return ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
          });
        }
      });
    },
    //详情
    details(row) {
      let params = row.no;
      if (row.status === "waiting") {
        window.open(
          "/shopDetails/" + sessionStorage.getItem("lang") + "/" + row.no,
          "_blank"
        );
        this.$router.push({
          name: "status",
          params: { params: row.no },
        });
      } else {
        this.$router.push({ name: "status", params: { params: params } });
      }
    },
    //取消订单
    cancel(trade_no) {
      ElMessageBox.confirm(
        this.t("orders.cancel_message"),
        this.t("orders.Attention"),
        {
          confirmButtonText: this.t("orders.sure"),
          cancelButtonText: this.t("orders.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          cancelOrder("", "?no=" + trade_no).then((res) => {
            if (res.data !== undefined) {
              if (res.data.code === 0) {
                this.getOrders();
                return ElNotification({
                  title: this.t("prompt.Success"),
                  message: this.t("prompt.cancel_success"),
                  type: "success",
                });
              } else {
                return ElNotification({
                  title: this.t("prompt.Mistake"),
                  message: res.data.msg,
                  type: "error",
                });
              }
            } else {
              return ElNotification({
                title: "Error",
                message: "Network error",
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    //转换
    changeTime(time) {
      return timeFilter(time);
    },
  },
  created() {
    let from = this.$route.query.from;
    let lang = this.$route.query.lang;
    if (from === "mobile") {
      //手机端app跳转,去掉头部和侧边
      this.store.commit("updateMobile", true);
      this.changelanguage(lang);
    }
    this.getOrders();
  },
  watch: {
    "$i18n.locale"() {
      this.getOrders();
    },
  },
};
</script>

<style scoped>
.orders {
  width: 100%;
  height: 100%;
  max-width: 1200px;
}
</style>